const MAX_401_REPLAYS = 1;

// On a 401 the shared response interceptor refreshes the session and resolves
// `undefined` (useCustomerApiAuthInterceptor.ts), so the generated mutator's
// `({ data }) => data` destructure throws a TypeError — that TypeError is the
// only signal an expired-session refresh happened. All engines' destructure
// messages contain "destructur"; the interceptor's own network-error TypeError
// ("reading 'status'") does not.
export const is401RefreshArtifact = (error: unknown): boolean =>
  error instanceof TypeError && /destructur/i.test(error.message);

// Replaces the app-wide `mutations.retry: 1` (containers/App.tsx) on a POST that
// must never be replayed blind: a 401 is rejected before the write lands, so one
// replay after refresh is duplicate-safe; a network/5xx retry could repeat the
// write and must never happen.
export const retryOnlyAfterRefresh = (
  failureCount: number,
  error: unknown
): boolean => failureCount < MAX_401_REPLAYS && is401RefreshArtifact(error);
